import React, { useEffect, useContext } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import moment from 'moment';
import StatusIcon from 'modules/common/components/StatusIcon';
import * as actions from '../action';
import * as c from '../constant';
import MemorandaModal from '../modals/MemorandaModal';
import ViewFaasModal from '../modals/ViewFaasModal';
import ViewTaxDeclarationModal from '../modals/ViewTaxDeclarationModal';

function Information({ data, getSingleLandOwner, landOwnerInfo, type }) {
  const setModal = useContext(ModalContext);

  const handleMemoranda = (item) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <MemorandaModal memorandaData={item} type={type} />,
      title: 'Memoranda',
      modalSize: 'modal-xl',
    });
  };

  const handleViewTaxDeclaration = (e) => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: <ViewTaxDeclarationModal data={data} type={type} />,
      title: `View Tax Declaration`,
      modalSize: 'modal-xl',
    });
  };

  const handleViewFaas = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <ViewFaasModal data={data} type={type} />,
      title: `View FAAS`,
      modalSize: 'modal-xl',
    });
  };

  useEffect(() => {
    getSingleLandOwner(_.get(data, 'attributes.rptax_owner_id'));
  }, []);

  useEffect(() => {
    getSingleLandOwner(_.get(data, 'attributes.rptax_owner_id'));
  }, [data]);

  const land_co_owner =
    type === 'history'
      ? _.get(data, 'included.land_application_co_owner_logs')
      : _.get(data, 'included.landApplicationCoOwners');

  return (
    <div className="row mb-1 p-3">
      <div className="d-flex ml-auto mb-3 mr-1">
        <div className="form-input-group mr-2">
          <button
            className="btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold"
            type="button"
            onClick={handleViewTaxDeclaration}
          >
            Tax Declaration
          </button>
        </div>
        <div className="form-input-group mr-2">
          <button
            disabled={_.get(data, 'attributes.status') !== 'POSTED'}
            className="btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold"
            type="button"
            onClick={handleViewFaas}
          >
            FAAS
          </button>
        </div>
        <div className="form-input-group mr-2">
          <button
            type="button"
            onClick={handleMemoranda(data)}
            className="btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold"
          >
            Memoranda&nbsp;
          </button>
        </div>
      </div>

      <div className="col-12">
        <table className="transaction-table table table-borderless table-striped table-sm ">
          <tbody>
            <tr>
              <td className="span-title2 font-weight-bold" width="250">
                Application Status
              </td>
              <td className="text-dark" width="1" />
              <td>
                <span className="p-0 d-flex">
                  <StatusIcon value={_.get(data, 'attributes.status')} />{' '}
                </span>
              </td>
            </tr>
            {data?.included?.changedCode?.attributes?.code === 'SD' &&
              _.get(data, 'attributes.status') === 'CANCELLED' && (
                <tr>
                  <td className="span-title2 font-weight-bold" width="250">
                    Remaining Area
                  </td>
                  <td className="text-dark" width="1" />
                  <td>{data?.attributes?.total_remaining_area || '0'}</td>
                </tr>
              )}
            <tr>
              <td className="span-title2 font-weight-bold" width="250">
                Transaction Name
              </td>
              <td className="text-dark" width="1" />
              <td>
                {_.get(data, 'included.transactionCode.attributes.name') ||
                  '--'}
              </td>
            </tr>
            <tr>
              <td className="span-title2 font-weight-bold" width="250">
                ARP No.
              </td>
              <td className="text-dark" width="1" />
              <td>{_.get(data, 'attributes.arp_no') || '--'}</td>
            </tr>
            <tr>
              <td className="span-title2 font-weight-bold" width="250">
                TDN
              </td>
              <td className="text-dark" width="1" />
              <td>{_.get(data, 'attributes.tdn') || '--'}</td>
            </tr>
            <tr>
              <td className="span-title2 font-weight-bold" width="250">
                PIN
              </td>
              <td className="text-dark" width="1" />
              <td>{_.get(data, 'attributes.pin') || '--'}</td>
            </tr>
            <tr>
              <td className="span-title2 font-weight-bold" width="250">
                OCT/TCT/CLOA No.
              </td>
              <td className="text-dark" width="1" />
              <td>{_.get(data, 'attributes.oct_tct_cloa_no') || '--'}</td>
            </tr>
            <tr>
              <td className="span-title2 font-weight-bold" width="250">
                OCT/TCT/CLOA Date
              </td>
              <td className="text-dark" width="1" />
              <td>{_.get(data, 'attributes.oct_tct_cloa_dated') || '--'}</td>
            </tr>
            <tr>
              <td className="span-title2 font-weight-bold" width="250">
                Survey No.
              </td>
              <td className="text-dark" width="1" />
              <td>{_.get(data, 'attributes.survey_no') || '--'}</td>
            </tr>
            <tr>
              <td className="span-title2 font-weight-bold" width="250">
                Date Registered
              </td>
              <td className="text-dark" width="1" />
              <td>
                {_.get(data, 'attributes.registered')
                  ? `${moment(_.get(data, 'attributes.registered')).format(
                    'MM/DD/YYYY HH:mm'
                  )}`
                  : '--'}
              </td>
            </tr>
            <tr>
              <td className="span-title2 font-weight-bold" width="250">
                Lot No.
              </td>
              <td className="text-dark" width="1" />
              <td>{_.get(data, 'attributes.lot_no') || '--'}</td>
            </tr>
            <tr>
              <td className="span-title2 font-weight-bold" width="250">
                Blk
              </td>
              <td className="text-dark" width="1" />
              <td>{_.get(data, 'attributes.blk') || '--'}</td>
            </tr>
            <tr>
              <td className="span-title2 font-weight-bold" width="250">
                Owner
              </td>
              <td className="text-dark" width="1" />
              <td>{_.get(landOwnerInfo, 'attributes.name') || '--'}</td>
            </tr>

            <tr>
              <td className="span-title2 font-weight-bold" width="250">
                Address
              </td>
              <td className="text-dark" width="1" />
              <td>{_.get(landOwnerInfo, 'attributes.address') || '--'}</td>
            </tr>
            <tr>
              <td className="span-title2 font-weight-bold" width="250">
                Tel No.
              </td>
              <td className="text-dark" width="1" />
              <td>{_.get(landOwnerInfo, 'attributes.telephone_no') || '--'}</td>
            </tr>
            <tr>
              <td className="span-title2 font-weight-bold" width="250">
                Tax Identification Number
              </td>
              <td className="text-dark" width="1" />
              <td>{_.get(landOwnerInfo, 'attributes.tin') || '--'}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="col-12 mt-1">
        <span className="title-color">Co Owners</span>
      </div>
      {land_co_owner && land_co_owner.length ? (
        land_co_owner.map((e) => (
          <div key={e.id} className="col-12">
            <table className="transaction-table table table-borderless table-striped table-sm ">
              <tbody>
                <tr>
                  <td className="span-title2 font-weight-bold" width="250">
                    Name
                  </td>
                  <td className="text-dark" width="1" />
                  <td>{_.get(e, 'attributes.details.name')}</td>
                </tr>
                <tr>
                  <td className="span-title2 font-weight-bold" width="250">
                    Address
                  </td>
                  <td className="text-dark" width="1" />
                  <td>{_.get(e, 'attributes.details.address')}</td>
                </tr>
                <tr>
                  <td className="span-title2 font-weight-bold" width="250">
                    Tel No.
                  </td>
                  <td className="text-dark" width="1" />
                  <td>{_.get(e, 'attributes.details.telephone_no')}</td>
                </tr>
                <tr>
                  <td className="span-title2 font-weight-bold" width="250">
                    Tax Identification Number
                  </td>
                  <td className="text-dark" width="1" />
                  <td>{_.get(e, 'attributes.details.tin')}</td>
                </tr>
              </tbody>
            </table>
          </div>
        ))
      ) : (
        <div className="col-12 mt-1 row d-flex">
          <div className="col-12 my-2 text-center">
            <span>No Co Owners</span>
          </div>
        </div>
      )}
      <div className="col-12 py-3 border-top" />
      <div className="col-12">
        <table className="transaction-table table table-borderless table-striped table-sm ">
          <tbody>
            <tr>
              <td className="span-title2 font-weight-bold" width="250">
                Administrator / Beneficial User
              </td>
              <td className="text-dark" width="1" />
              <td>
                {_.get(data, 'attributes.administrator_beneficial_user') ||
                  '--'}
              </td>
            </tr>
            <tr>
              <td className="span-title2 font-weight-bold" width="250">
                Address
              </td>
              <td className="text-dark" width="1" />
              <td>
                {_.get(data, 'attributes.administrator_beneficial_address') ||
                  '--'}
              </td>
            </tr>
            <tr>
              <td className="span-title2 font-weight-bold" width="250">
                Tel No.
              </td>
              <td className="text-dark" width="1" />
              <td>
                {_.get(
                  data,
                  'attributes.administrator_beneficial_telephone_no'
                ) || '--'}
              </td>
            </tr>
            <tr>
              <td className="span-title2 font-weight-bold" width="250">
                Tax Identification Number
              </td>
              <td className="text-dark" width="1" />
              <td>
                {_.get(data, 'attributes.administrator_beneficial_tin') || '--'}
              </td>
            </tr>
            <tr>
              <td className="span-title2 font-weight-bold" width="250">
                Effectivity of Assessment / Reassessment QTR
              </td>
              <td className="text-dark" width="1" />
              <td>
                {_.get(
                  data,
                  'attributes.effectivity_of_assessment_reassessment_qtr'
                ) || '--'}
              </td>
            </tr>
            <tr>
              <td className="span-title2 font-weight-bold" width="250">
                Effectivity of Assessment / Reassessment Year
              </td>
              <td className="text-dark" width="1" />
              <td>
                {_.get(
                  data,
                  'attributes.effectivity_of_assessment_reassessment_yr'
                ) || '--'}
              </td>
            </tr>
            <tr>
              <td className="span-title2 font-weight-bold" width="250">
                Appraised/Assessed By
              </td>
              <td className="text-dark" width="1" />
              <td>{_.get(data, 'attributes.appraised_assessed_by') || '--'}</td>
            </tr>
            <tr>
              <td className="span-title2 font-weight-bold" width="250">
                Appraised/Assessed At
              </td>
              <td className="text-dark" width="1" />
              <td>{_.get(data, 'attributes.appraised_assessed_at') || '--'}</td>
            </tr>

            <tr>
              <td className="span-title2 font-weight-bold" width="250">
                Recommended By
              </td>
              <td className="text-dark" width="1" />
              <td>{_.get(data, 'attributes.recommending_by') || '--'}</td>
            </tr>
            <tr>
              <td className="span-title2 font-weight-bold" width="250">
                Recommended At
              </td>
              <td className="text-dark" width="1" />
              <td>{_.get(data, 'attributes.recommending_at') || '--'}</td>
            </tr>
            <tr>
              <td className="span-title2 font-weight-bold" width="250">
                Approved By
              </td>
              <td className="text-dark" width="1" />
              <td>{_.get(data, 'attributes.approved_by') || '--'}</td>
            </tr>
            <tr>
              <td className="span-title2 font-weight-bold" width="250">
                Approved At
              </td>
              <td className="text-dark" width="1" />
              <td>{_.get(data, 'attributes.approved_at') || '--'}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

Information.defaultProps = {
  type: '',
};

Information.propTypes = {
  // handleMemoranda: PropTypes.instanceOf(Function).isRequired,
  data: PropTypes.instanceOf(Object).isRequired,
  getSingleLandOwner: PropTypes.instanceOf(Function).isRequired,
  landOwnerInfo: PropTypes.instanceOf(Object).isRequired,
  type: PropTypes.string,
};

const mapStateToProps = ({ api }) => ({
  landOwnerInfo: _.get(api, `${c.GET_SINGLE_LAND_OWNER}.item`) || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(Information);
